import {
  RequiredToggle,
  ReadOnlyToggle,
} from 'apps/builder/components/settings/modal/shared'
import { SettingsFieldSelect } from 'apps/builder/components/settings/modal/shared'
import { useDispatch } from 'react-redux'
import { Input } from 'components/Input/Input'
import { updateEntry } from 'apps/builder/store/actions/entries'

export const BarcodeField = ({
  guid,
  label,
  required,
  read_only,
  default: defaultValue,
  type,
  keyField,
}) => {
  const dispatch = useDispatch()

  const updateDefaultValue = value => {
    dispatch(
      updateEntry({
        guid,
        default: value,
      })
    )
  }

  const inputProps = {
    value: defaultValue || '',
    update: updateDefaultValue,
    additionalClass: 'settings--inputs',
    label: 'Default Value',
  }

  return (
    <>
      <div className="settings--row">
        <SettingsFieldSelect
          guid={guid}
          label={label}
          keyField={keyField}
          type={type}
        />

        <div className="toggles-group">
          <div className="toggle-wrapper">
            <RequiredToggle guid={guid} active={required} />
          </div>
          <div className="toggle-wrapper">
            <ReadOnlyToggle guid={guid} active={read_only} />
          </div>
        </div>
      </div>
      <div className="settings--default-value">
        <Input {...inputProps} />
      </div>
    </>
  )
}
